import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Pray/Pray.tsx");
